module.exports = __webpack_public_path__ + "static/media/materialWavingPerson.2c591ba9.svg";